import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["themeOption"]

  connect() {
    // Load saved theme from localStorage or default to 'light'
    const savedTheme = localStorage.getItem('daisyui-theme') || 'light'
    this.setTheme(savedTheme)

    // Highlight the current theme in the dropdown
    this.highlightCurrentTheme(savedTheme)
  }

  setTheme(event) {
    let theme
    if (typeof event === 'string') {
      theme = event
    } else {
      theme = event.currentTarget.dataset.theme
    }

    // Set the theme on the html element
    document.documentElement.setAttribute('data-theme', theme)

    // Save to localStorage
    localStorage.setItem('daisyui-theme', theme)

    // Highlight the current theme
    this.highlightCurrentTheme(theme)

    // Close the dropdown
    this.closeDropdown()
  }

  highlightCurrentTheme(theme) {
    // Remove active class from all theme options
    this.themeOptionTargets.forEach(option => {
      option.classList.remove('active')
    })

    // Add active class to current theme
    const currentThemeOption = this.themeOptionTargets.find(option =>
      option.dataset.theme === theme
    )
    if (currentThemeOption) {
      currentThemeOption.classList.add('active')
    }
  }

  closeDropdown() {
    // Find and close the dropdown by removing the 'open' class
    const dropdown = this.element.querySelector('.dropdown')
    if (dropdown) {
      dropdown.classList.remove('dropdown-open')
    }
  }
}
